module.exports = __webpack_public_path__ + "img/stories-tablet-english.b3ad98c0.png";